import { IRouteDefinition, RouterState } from '@estee/elc-router';
import { scrollToTargets } from '../utils/ScrollTo';

export const DEFAULT = Object.freeze({
  ROUTE: 'default',
  ROUTE_PATTERN: '/',
});

export const PAYMENT = Object.freeze({
  ROUTE: 'payment',
  ROUTE_PATTERN: '/payment',
});

export const NOT_FOUND = Object.freeze({
  ROUTE: 'notFound',
  ROUTE_PATTERN: '/not-found',
});

export const DELIVERY = Object.freeze({
  ROUTE: 'delivery',
  ROUTE_PATTERN: '/delivery',
});

export const INCOMPATIBLE_BROWSER = Object.freeze({
  ROUTE: 'incompatible-browser',
  ROUTE_PATTERN: '/incompatible-browser',
});

export const ROUTES: IRouteDefinition [] = [
  {
    name: DEFAULT.ROUTE,
    onEnter: (fromState: RouterState, toState: RouterState): Promise<void> => {
      if (fromState.routeName === PAYMENT.ROUTE && toState.params.isExpressFlow) {
        return Promise.reject(new RouterState(PAYMENT.ROUTE));
      }
      return Promise.reject(new RouterState(DELIVERY.ROUTE));
    },
    pattern: DEFAULT.ROUTE_PATTERN,
  },
  {
    name: DELIVERY.ROUTE,
    onEnter: () => {
      scrollToTargets('header');
    },
    pattern: DELIVERY.ROUTE_PATTERN,
  },
  {
    name: PAYMENT.ROUTE,
    onEnter: () => {
      scrollToTargets('header');
    },
    pattern: PAYMENT.ROUTE_PATTERN,
  },
  {
    name: NOT_FOUND.ROUTE,
    pattern: NOT_FOUND.ROUTE_PATTERN,
  },
  {
    name: INCOMPATIBLE_BROWSER.ROUTE,
    pattern: INCOMPATIBLE_BROWSER.ROUTE_PATTERN,
  },
];

export const EXTERNAL_ROUTES = {
  CART: '/checkout/viewcart.tmpl',
  SESSION_EXPIRED: '/account/signin.tmpl?_SUBMIT=signout&timeout=1',
  SIGNED_OUT: '/account/signin.tmpl?_SUBMIT=signout',
};
